import { z } from "zod";

import { CANDIDATE_STATUSES } from "../types/candidate";

export const rejectCandidateSchema = z.object({
  reason: z.string().min(3, "Ein Grund ist Pflicht (min. 3 Zeichen)."),
});
export type RejectCandidateInput = z.infer<typeof rejectCandidateSchema>;

export const updateCandidateStatusSchema = z.object({
  candidateId: z.string(),
  // `in_review` is display-only (ADR 0004), never a status change.
  status: z.enum(CANDIDATE_STATUSES).exclude(["in_review"]),
  rejectionReason: z.string().nullable().optional(),
  // Optional, for a move back to the Longlist (#162).
  reason: z.string().nullable().optional(),
});
export type UpdateCandidateStatusInput = z.infer<typeof updateCandidateStatusSchema>;
